import { defineStore } from "pinia";
import {
    API_RESPONSE_SUCCESS,
    BAD_REQUEST_ERROR_CODE,
    COUNTRY_CODE_JA,
    HTTP_CODE_SUCCESS
} from "@/data/constants";
import { handleError } from "@/helpers/helpers";
import ApplicationError from "@/helpers/applicationError";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";

const apiGatewayRepository = RepositoryFactory.get("apiGateway");

export const useShippingAddressStore = defineStore("shippingAddress", {
    id: "shippingAddress",
    state: () => {
        return {
            isLoading: false,
            isAddressEdit: false,
            addresses: {},
            addressForm: {
                "address_1": null,
                "first_name": null,
                "last_name": null,
                "first_name_kana": null,
                "last_name_kana": null,
                "tel": null,
                "address_1": null,
                "address_2": null,
                "address_3": null,
                "zip_code": null
            },
            addressFormErrors: {},
            addressFormErrorMsg: null
        };
    },
    getters: {
        getAddressForm(state) {
            return state.addressForm;
        },
    },
    actions: {
        async getShippingAddresses() {
            try {
                this.isLoading = true;

                const response = await apiGatewayRepository.getShippingAddresses();
                if (response.data != null && response.success == API_RESPONSE_SUCCESS) {
                    this.addresses = response.data;
                }

                this.isLoading = false;
            } catch (e) {
                this.isLoading = false;
                const errorMessage = await handleError(e);
                throw new ApplicationError(errorMessage, {}, e);
            }
        },
        async registerAddress() {
            try {
                this.isLoading = true;

                const response = await apiGatewayRepository.createShippingAddresses(this.getNormalizeAddressForm());
                if (response.code === HTTP_CODE_SUCCESS) {
                    await this.getShippingAddresses();
                    this.resetAddressForm();
                    this.isLoading = false;

                    return true;
                }

                return false;
            } catch (error) {
                this.isLoading = false;
                if (error.response.data && error.response.data.errors) {
                    const data = error.response.data;

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "object") {
                        this.addressFormErrors = data.errors;
                    }

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "string") {
                        this.addressFormErrorMsg = data.errors;
                    }

                    return false;
                }
                throw new ApplicationError(error.message, {}, error);
            }
        },
        async updateAddress() {
            try {
                this.isLoading = true;

                let params = this.getAddressForm;
                params.address_1 = params.address_1.toString();
                const response = await apiGatewayRepository.updateShippingAddresses(params);
                if (response.code === HTTP_CODE_SUCCESS) {
                    await this.getShippingAddresses();
                    this.resetAddressForm();
                    this.isLoading = false;

                    return true;
                }

                return false;
            } catch (error) {
                this.isLoading = false;
                if (error.response.data && error.response.data.errors) {
                    const data = error.response.data;

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "object") {
                        this.addressFormErrors = data.errors;
                    }

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "string") {
                        this.addressFormErrorMsg = data.errors;
                    }

                    return false;
                }
                throw new ApplicationError(error.message, {}, error);
            }
        },
        async setDefaultAddress(address) {
            try {
                this.isLoading = true;

                let params = {
                    address_id: address.user_address_id.toString(),
                    default_flag: 1
                };

                const response = await apiGatewayRepository.updateShippingAddresses(params);
                if (response.code === HTTP_CODE_SUCCESS) {
                    await this.getShippingAddresses();
                    this.resetAddressForm();
                    this.isLoading = false;

                    return true;
                }

                return false;
            } catch (error) {
                this.isLoading = false;
                if (error.response.data && error.response.data.errors) {
                    const data = error.response.data;

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "object") {
                        this.addressFormErrors = data.errors;
                    }

                    if (data.code === BAD_REQUEST_ERROR_CODE && typeof data.errors === "string") {
                        this.addressFormErrorMsg = data.errors;
                    }

                    return false;
                }
                throw new ApplicationError(error.message, {}, error);
            }
        },
        async deleteAddress(addressId) {
            try {
                this.isLoading = true;

                await apiGatewayRepository.deleteShippingAddress({ "address_id": addressId.toString() });
                await this.getShippingAddresses();

                this.isLoading = false;
            } catch (e) {
                this.isLoading = false;
                this.ErrorMessage = await handleError(e);

                throw new ApplicationError(e.message, addressId, e)
            }
        },
        getNormalizeAddressForm() {
            let params = this.getAddressForm;
            params.address_1 = params.address_1.toString();
            params.country = COUNTRY_CODE_JA.toString();
            params.default_flag = 0;

            return params;
        },
        resetAddressForm() {
            Object.assign(this.addressForm, {
                "address_1": null,
                "first_name": null,
                "last_name": null,
                "first_name_kana": null,
                "last_name_kana": null,
                "tel": null,
                "address_1": null,
                "address_2": null,
                "address_3": null,
                "zip_code": null
            });
            this.addressFormErrors = {};
            this.addressFormErrorMsg = null;
        },
        makeEditFormInputs(address) {
            this.addressForm.address_id = address.user_address_id.toString();
            this.addressForm.first_name = address.delivering_address_first_name;
            this.addressForm.last_name = address.delivering_address_last_name;
            this.addressForm.first_name_kana = address.delivering_address_first_name_kana;
            this.addressForm.last_name_kana = address.delivering_address_last_name_kana;
            this.addressForm.tel = address.tel;
            this.addressForm.zip_code = address.zip_code;
            this.addressForm.address_1 = address.address_1;
            this.addressForm.address_2 = address.address_2;
            this.addressForm.address_3 = address.address_3;
            this.addressForm.default_flag = address.default_flag === "true" ? 1 : 0;
        }
    },
});